import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { get } from 'lodash';
import PageHelmet from '@bd/bdcore-pagehelmet';
import InsideHeader from '../../components/InsideHeader';
import PageWrapper from '../../components/PageWrapper';
import { colors } from '../../styles';

const styles = css`
.TourGallery_categoryTitle {
  font-weight: 800;
  font-size: 24px;
  padding-top: 30px;
  color: #3F3F3F;
  letter-spacing: 4px;
  text-align: center;
  line-height: 36px;
  text-transform: uppercase;
  margin: 40px 0 80px 0;
  position: relative;
  @media (min-width: 992px) {
    font-size: 41px;
    margin: 0 0 80px 0;
  }
  &:after {
    content: '';
    position: absolute;
    display: block;
    width: 150px;
    height: 3px;
    left: 50%;
    margin-left: -75px;
    background-color: ${colors.color3};
    bottom: -40px;
  }
}
  .TourSection_item {
    margin: 0 0 25px 0;
    @media(min-width: 992px) {
      margin: 0 0 40px 0;
  }
  .Tour_embed {
    padding-left: 20px;
    padding-right: 20px;
  }
`;

function VirtualTours({ page }) {
  return (
    <div className={styles}>
      <PageWrapper className={styles}>
        <PageHelmet page={page} />
        <InsideHeader
          h1={`${page.meta.name}`}
          background={get(page, 'page_image.contentUrl')}
        />
        <div className="row">
          <div className="col-lg-8 mx-auto">
            <h3 className="TourGallery_categoryTitle">Virtual Tours</h3>
            {
              get(page, 'virtual_tours', []).length > 0 &&
              <ul className="list-unstyled row">
                {
                  get(page, 'virtual_tours', []).map(tour => {
                    return (
                      <li key={tour._id} className="TourSection_item col-lg-6 embed-responsive embed-responsive-16by9">
                        <iframe className="Tour_embed embed-responsive-item" title="intest" src={tour.tour_url} />
                      </li>
                    );
                  })
                }
              </ul>
            }
          </div>
        </div >
      </PageWrapper>
    </div>
  );
}

VirtualTours.propTypes = {
  page: PropTypes.object.isRequired,
};
export default withData({
  page: 'virtual_tours',
})(VirtualTours);



// WEBPACK FOOTER //
// ./src/pages/VirtualTour/index.js